import React, { useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import SearchInput from "../elements/SearchInput.jsx";
import { searchTransactions } from "../../redux/actions/transactions.js";

export default function TransactionSearch() {

	const dispatch = useDispatch();
	const text = useSelector((state) => {
		return state.transactions.transactionSearchText;
	});

	const searchTransactionsChange = useCallback((value) => {
		dispatch(searchTransactions(value));
	}, []);

	return (
		<SearchInput
			className='transaction_search'
			placeholder='Search transactions'
			onChange={searchTransactionsChange}
			value={text}
		/>
	);
}
